import React, { Component } from 'react';
import InputGradesFilterStudents from '../../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';

class StudentFilterExamRegistration extends Component {
    componentDidMount() {
        localStorage.setItem('redirectType', 'examRegistration');
    }
    render() {
        return (
            <div>
                <h1>Prijava ispita</h1>
                <InputGradesFilterStudents
                    redirectType="examRegistration"
                />
            </div>
        );
    }
}

export default StudentFilterExamRegistration;


// WEBPACK FOOTER //
// ./src/views/Admin/Students/ExamRegistration/StudentFilterExamRegistration.js